import { WATCH_RECORDINGS_IDS_LIST_STORAGE_KEY } from '../constants';
import type { State, Store } from '../../../types';

export const setupSetWatchedRecordingsOnRecordingChange = (store: Store): void => {
  const searchParams = new URLSearchParams(window.location.search);

  // Prevent watched recordings change for a public recording
  const token = searchParams.get('token');
  if (token) return;

  store.subscribe(
    (state: State) => {
      const { recording, recordingId, watchedRecordingsIdsList, setWatchedRecordingsIdsList } =
        state;

      if (!recording || watchedRecordingsIdsList?.includes(recordingId)) return;

      // Set recordings as watched
      const updatedWatchedRecordingsIdsList = watchedRecordingsIdsList
        ? [recording.id, ...watchedRecordingsIdsList]
        : [recording.id];
      localStorage.setItem(
        WATCH_RECORDINGS_IDS_LIST_STORAGE_KEY,
        JSON.stringify(updatedWatchedRecordingsIdsList),
      );
      setWatchedRecordingsIdsList(updatedWatchedRecordingsIdsList);
    },
    (state: State) => state,
    (state: State, newState: State) => state.recording === newState.recording,
  );
};
